/* ====================================
   AATVI DÉCOR - MOBILE NAVIGATION JS
   File: assets/mobile-nav.js
   ==================================== */

(function() {
  'use strict';

  // Elements
  const overlay = document.getElementById('mobileNavOverlay');
  const container = document.getElementById('mobileNavContainer');
  const backBtn = document.getElementById('mobileNavBack');
  const closeBtn = document.getElementById('mobileNavClose');
  const levels = document.querySelectorAll('.mobile-nav-level');
  
  // State
  let levelStack = ['mainMenu'];
  let currentLevel = 'mainMenu';

  // Initialize
  function init() {
    // Find and attach click handler to hamburger menu button
    const menuBtn = document.querySelector('[data-mobile-nav-trigger]') || 
                    document.querySelector('.mobile-menu-btn') ||
                    document.querySelector('.hamburger-btn');
    
    if (menuBtn) {
      menuBtn.addEventListener('click', openNav);
    }

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
    }

    // Overlay click
    if (overlay) {
      overlay.addEventListener('click', closeNav);
    }

    // Back button
    if (backBtn) {
      backBtn.addEventListener('click', goBack);
    }

    // Main category buttons
    const categoryBtns = document.querySelectorAll('[data-category]');
    categoryBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const category = this.getAttribute('data-category');
        navigateTo(category + 'Menu');
      });
    });

    // Submenu buttons
    const submenuBtns = document.querySelectorAll('[data-submenu]');
    submenuBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const submenu = this.getAttribute('data-submenu');
        navigateTo(submenu + 'Menu');
      });
    });

    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && container.classList.contains('active')) {
        closeNav();
      }
    });

    // Prevent body scroll when nav is open
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if (container.classList.contains('active')) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.overflow = '';
          }
        }
      });
    });

    if (container) {
      observer.observe(container, { attributes: true });
    }
  }

  // Open Navigation
  function openNav() {
    if (overlay && container) {
      overlay.classList.add('active');
      container.classList.add('active');
      
      // Reset to main menu
      resetToMain();
    }
  }

  // Close Navigation
  function closeNav() {
    if (overlay && container) {
      overlay.classList.remove('active');
      container.classList.remove('active');
      
      // Reset after animation
      setTimeout(resetToMain, 300);
    }
  }

  // Navigate to a level
  function navigateTo(levelId) {
    const targetLevel = document.getElementById(levelId);
    
    if (!targetLevel) {
      console.warn('Level not found:', levelId);
      return;
    }

    // Hide current level
    const currentLevelEl = document.getElementById(currentLevel);
    if (currentLevelEl) {
      currentLevelEl.classList.remove('active');
    }

    // Show target level
    targetLevel.classList.add('active');
    
    // Update state
    currentLevel = levelId;
    levelStack.push(levelId);
    
    // Show back button
    updateBackButton();
    
    // Scroll to top
    const content = document.querySelector('.mobile-nav-content');
    if (content) {
      content.scrollTop = 0;
    }
  }

  // Go Back
  function goBack() {
    if (levelStack.length <= 1) return;
    
    // Remove current level
    levelStack.pop();
    
    // Get previous level
    const previousLevelId = levelStack[levelStack.length - 1];
    const previousLevel = document.getElementById(previousLevelId);
    const currentLevelEl = document.getElementById(currentLevel);
    
    if (previousLevel && currentLevelEl) {
      // Hide current
      currentLevelEl.classList.remove('active');
      
      // Show previous
      previousLevel.classList.add('active');
      
      // Update state
      currentLevel = previousLevelId;
      
      // Update back button
      updateBackButton();
      
      // Scroll to top
      const content = document.querySelector('.mobile-nav-content');
      if (content) {
        content.scrollTop = 0;
      }
    }
  }

  // Update Back Button Visibility
  function updateBackButton() {
    if (backBtn) {
      if (levelStack.length > 1) {
        backBtn.classList.add('visible');
      } else {
        backBtn.classList.remove('visible');
      }
    }
  }

  // Reset to Main Menu
  function resetToMain() {
    // Hide all levels
    levels.forEach(level => {
      level.classList.remove('active');
    });
    
    // Show main menu
    const mainMenu = document.getElementById('mainMenu');
    if (mainMenu) {
      mainMenu.classList.add('active');
    }
    
    // Reset state
    levelStack = ['mainMenu'];
    currentLevel = 'mainMenu';
    
    // Hide back button
    updateBackButton();
    
    // Scroll to top
    const content = document.querySelector('.mobile-nav-content');
    if (content) {
      content.scrollTop = 0;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose openNav globally for manual triggering
  window.openMobileNav = openNav;
  window.closeMobileNav = closeNav;

})();